import { createContext, type Dispatch, type SetStateAction } from "react";
import { ExpenseFragmentFragment } from "gql/index";

export type CostItemEntryType = 'expense' | 'quote';

export type QuoteEntry = {
  id: number;
  name: string;
  amount: number;
  quoteDate: string;
  attachments?: { id: number; fileName: string; thumbnailStatus?: string }[];
};

export type EntryDialogState =
  | { open: false }
  | {
      open: true;
      costItemId: number;
      type: CostItemEntryType;
      expense?: ExpenseFragmentFragment;
      quote?: QuoteEntry;
    };

interface IBudgetTableContext {
  entryDialog: EntryDialogState;
  setEntryDialog: Dispatch<SetStateAction<EntryDialogState>>;
  allowAddingExpenseToQuote: boolean;
}

export const BudgetTableContext = createContext<IBudgetTableContext>({
  entryDialog: { open: false },
  setEntryDialog: () => {},
  allowAddingExpenseToQuote: false,
});